import React, { useRef } from 'react';
import clsx from 'clsx';

import CommonLoader from '../../../components/common-loader/CommonLoader';
import EmptyMessagesList from './EmptyMessagesList';

import scss from './MessagesList.module.scss';

function MessagesList({ content, className, renderMessage, isLoading = false, maxHeight }) {
  const listRef = useRef(null);

  return (
    <div ref={listRef} className={clsx(scss.list, className)} style={{ maxHeight }}>
      {content.length ? content.map(renderMessage) : <EmptyMessagesList />}
      <CommonLoader isLoading={isLoading} scrollableRef={listRef} disableScrolling />
    </div>
  );
}

export default MessagesList;
